import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { ReportMessageType } from '~/shared';

const StyledContainer = styled.div<{
	$type: ReportMessageType;
	$isFirst?: boolean;
	$isContinuation?: boolean;
}>`
	display: flex;
	flex-direction: column;
	gap: 20px;
	align-items: ${({ $type }) =>
		$type === ReportMessageType.INCOMING ? 'flex-start' : 'flex-end'};
	margin-top: ${({ $isFirst, $isContinuation }) =>
		$isFirst ? '0' : $isContinuation ? '10px' : '30px'};
`;

const StyledInfoContainer = styled.div<{ $type: ReportMessageType }>`
	display: flex;
	gap: 10px;
	align-items: flex-start;
	flex-direction: ${({ $type }) =>
		$type === ReportMessageType.INCOMING ? 'row' : 'row-reverse'};
`;

const StyledImage = styled.img<{ $online?: boolean; $isStaff?: boolean }>`
	width: 40px;
	height: 40px;
	border-radius: 40px;

	${({ $isStaff, $online }) =>
		$isStaff
			? css`
					padding: 2px;
					border: 2px solid #c71e1e;
			  `
			: $online
			? css`
					padding: 2px;
					border: 2px solid #77de38;
			  `
			: css`
					filter: grayscale(1);
			  `}
`;

const StyledNameContainer = styled.div<{
	$type: ReportMessageType;
	$isStaff?: boolean;
	$online?: boolean;
}>`
	display: flex;
	flex-direction: column;
	align-items: ${({ $type }) =>
		$type === ReportMessageType.INCOMING ? 'flex-start' : 'flex-end'};
	margin-top: 4px;

	${Text} {
		font-weight: 500;

		&.name {
			font-size: 16px;
			color: #ffffff;
		}

		&.status {
			font-size: 12px;
			color: ${({ $online, $isStaff }) =>
				$isStaff
					? '#C71E1E'
					: $online
					? '#77DE38'
					: 'rgba(255, 255, 255, 0.5)'};
		}
	}
`;

const StyledTimeText = styled(Text)`
	font-weight: 500;
	font-size: 16px;
	color: #ffffff;
	opacity: 0.25;
	margin-top: 4px;
`;

const StyledTextContainer = styled.div`
	padding: 16.5px 20px;
	background: rgba(255, 255, 255, 0.05);
	border-radius: 10px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

export {
	StyledContainer,
	StyledImage,
	StyledInfoContainer,
	StyledNameContainer,
	StyledTextContainer,
	StyledTimeText,
};
